import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect() {
        const video = this.element.querySelector('video');
        this.element.addEventListener('click', (e) => {
            if ( !this.element.classList.contains('video-playing') ) {
                e.preventDefault();
                this.toggleControlls();
            }
        });

        video.addEventListener('play', () => {
            if ( !this.element.classList.contains('video-playing') ) {
                this.toggleControlls();
            }
        });

        video.addEventListener('pause', () => {
            this.toggleControlls();
        });
    }

    toggleControlls() {
        const video = this.element.querySelector('video');
        this.element.classList.toggle('video-playing');
        if (this.element.classList.contains('video-playing')) {
            video.setAttribute('controls', 'true');
            video.play();
        } else {
            video.removeAttribute('controls');
        }
    }
}
